import { render, staticRenderFns } from "./ReadPDF.vue?vue&type=template&id=b4669bbe&"
import script from "./ReadPDF.vue?vue&type=script&lang=js&"
export * from "./ReadPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports